export default "/_next/static/chunks/fonts/Lato-Bold-latin-715cc83767e6bd43255ca6d44df22ac7.woff2";